













































































































































































































































































































import Mixins from './mixin'
import SeriesTable from './series-table.vue'

// eslint-disable-next-line
import 'verte/dist/verte.css'
const Verte = require('verte').default

export default Mixins.extend({
  name: 'TrendEditor',
  components: {
    Verte,
    SeriesTable,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  created() {
    this.parseInput()
  },
})
